import { Wifi, WifiOff, RefreshCw } from 'lucide-react';
import type { ConnectionState } from '../types';

interface ConnectionStatusProps {
  connection: ConnectionState;
}

export function ConnectionStatus({ connection }: ConnectionStatusProps) {
  const { isConnected, isReconnecting } = connection;

  if (isReconnecting) {
    return (
      <div className="flex items-center gap-2 text-yellow-600 dark:text-yellow-400">
        <RefreshCw className="w-4 h-4 animate-spin" />
        <span className="text-sm font-medium">Reconnecting...</span>
      </div>
    );
  }

  if (isConnected) {
    return (
      <div className="flex items-center gap-2 text-green-600 dark:text-green-400">
        <div className="relative">
          <Wifi className="w-4 h-4" />
          <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-green-500 dark:bg-green-400 rounded-full animate-pulse" />
        </div>
        <span className="text-sm font-medium">Live updates</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-red-600 dark:text-red-400">
      <WifiOff className="w-4 h-4" />
      <span className="text-sm font-medium">Disconnected</span>
    </div>
  );
}
